/**
 * Aplica tema y plantilla al `html`.  (spec 043)
 *
 * Sin sesión: auto + Default. Con sesión: lo guardado.
 * `auto` escucha el sistema sin recargar.
 */
import { useLayoutEffect, useState, type ReactNode } from 'react'

import { useSesion } from './auth'
import {
    aplicarApariencia,
    PLANTILLA_DEFECTO,
    TEMA_DEFECTO,
    type TemaEfectivo,
} from './lib/apariencia'

function useEsquemaSistema(): TemaEfectivo {
    const [sistema, setSistema] = useState<TemaEfectivo>(() => {
        if (typeof window === 'undefined') return 'dark'
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
    })
    useLayoutEffect(() => {
        const mq = window.matchMedia('(prefers-color-scheme: dark)')
        const sync = () => setSistema(mq.matches ? 'dark' : 'light')
        sync()
        mq.addEventListener('change', sync)
        return () => mq.removeEventListener('change', sync)
    }, [])
    return sistema
}

export function AparienciaRoot({ children }: { children: ReactNode }) {
    const { data } = useSesion()
    const sistema = useEsquemaSistema()
    const tema = data?.apariencia?.tema ?? TEMA_DEFECTO
    const plantilla = data?.apariencia?.plantilla ?? PLANTILLA_DEFECTO

    useLayoutEffect(() => {
        aplicarApariencia({ tema, plantilla, sistema })
    }, [tema, plantilla, sistema])

    return children
}
